module.exports = __webpack_public_path__ + "img/floor_f9_01.4bcc6162.png";